import { Dispatch, ThunkAction } from '../../../types/actions';
import { IGetState } from '../../../types/types';
import { IAuthUser } from '../../../store/model/authUser/types';
import { authUserPatch } from './api/helper/authUserPatch';
import { TSortedSavedFiltersIds } from '../../../types/rest/IUserMeta';

export const authUserSetSortedSavedFiltersIds = (
    userId: string,
    sortedSavedFiltersIds: TSortedSavedFiltersIds
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const userPatch: IAuthUser = {
            id: userId,
            meta: {
                sortedSavedFiltersIds
            }
        };
        return dispatch(authUserPatch(userPatch));
    };
    return action;
};
